import { sha256 } from 'js-sha256';
import accessList from '../access.json';
import { makeObservable, computed, observable, action } from 'mobx';

export type ConfiguratorId = string;

export class AuthorizationService {
  accessibleConfigurators: ConfiguratorId[] = [];

  constructor() {
    makeObservable(this, {
      isAuthorized: computed,
      accessibleConfigurators: observable,
      authorize: action.bound
    });
  }

  get isAuthorized() {
    return !this.accessibleConfigurators.length;
  }

  authorize(token: string): boolean {
    const hash = sha256(token);
    const accessRecord = accessList.find((record) => record.hash === hash);
    if (accessRecord) {
      this.accessibleConfigurators = accessRecord.configurators;
      return true;
    } else {
      this.accessibleConfigurators = [];
      return false;
    }
  }

  hasAccessTo(configuratorId: ConfiguratorId) {
    if (process.env.NODE_ENV === 'development') {
      return true;
    }
    return this.accessibleConfigurators.includes(configuratorId);
  }
}

export const authorizationService = new AuthorizationService();
